// Gatsby requirements
import React from 'react'
import { Link, useStaticQuery, graphql } from 'gatsby'
import { storyblokEditable } from "gatsby-source-storyblok";

// Components
import Image from "utils/Image"
import Json from './ListOfArticles.json'
import RichText from "utils/RichTextRenderer"

// Styles
import * as CSS from './ListOfArticles.module.scss'


const ListOfArticles = ({ data }) => {

    const query = useStaticQuery(graphql`
        query {
            categoryTags: allStoryblokDatasourceEntry(filter: {data_source: {eq: "blog-tags"}}) {
                nodes {
                name
                value
                }
            }
            patientResourceTags: allStoryblokDatasourceEntry(filter: {data_source: {eq: "patient-resource-tags"}}) {
                nodes {
                    name
                    value
                }
            }
        }
    `)

    return (
        <section {...storyblokEditable(data)} className={`
            ${CSS.section}
            ${'section' + data._uid}
        `}>

            {data?.css &&
                <style dangerouslySetInnerHTML={{__html:
                    data.css.replaceAll('.section', '.section' + data._uid).replaceAll('.top-text', '.top-text' + data._uid).replaceAll('.wrapper', '.wrapper' + data._uid)
                }} />
            }

            <div className={`${CSS.container} ${'wrapper' + data._uid}`}>

                <h2 className={CSS.title}>{data.title}</h2>

                <div className={`${CSS.topText} ${'top-text' + data._uid}`}>
                    <RichText content={data?.topText} />
                </div>

                <div className={CSS.wrapper}>
                    {data?.articlesFromTag && Json?.map((article, i) => {
                        if (article?.category?.includes(data?.articlesFromTag)) {
                            return (
                                <article key={i}>
                                    <div>
                                        {article?.thumbnail &&
                                            <div className={CSS.image}>
                                                <Image img={article.thumbnail} />
                                            </div>
                                        }
                                        {article?.title &&
                                            <Link to={`/${article.full_slug}/`}>
                                                <h3>{article.title}</h3>
                                            </Link>
                                        }
                                    </div>

                                    {article?.category && article.category[0] &&
                                        <Link className={CSS.categoryTag} to={`/learn/categories/${article.category[0]}/`}>
                                            {query.categoryTags.nodes.find(({value}) => value === article.category[0])?.name}
                                        </Link>
                                    }
                                </article>
                            )
                        }
                    })}

                    {data?.articlesFromPatientResourcesTag && Json?.map((article, i) => {
                        if (article?.patientResourcesCategory?.includes(data?.articlesFromPatientResourcesTag)) {
                            return (
                                <article key={i}>
                                    <div>
                                        {article?.thumbnail &&
                                            <div className={CSS.image}>
                                                <Image img={article.thumbnail} />
                                            </div>
                                        }
                                        {article?.title &&
                                            <Link to={`/${article.full_slug}/`}>
                                                <h3>{article.title}</h3>
                                            </Link>
                                        }
                                    </div>

                                    {article?.patientResourcesCategory && article.patientResourcesCategory[0] &&
                                        <Link className={CSS.categoryTag} to={`/patient-resources/categories/${article.patientResourcesCategory[0]}/`}>
                                            {query.patientResourceTags.nodes.find(({value}) => value === article.patientResourcesCategory[0])?.name}
                                        </Link>
                                    }
                                </article>
                            )
                        }
                    })}

                    {data?.manualArticles?.map((id, i) => {
                        const article = Json?.find(({uuid}) => uuid === id)
                        return (
                            <article key={i}>
                                <div>
                                    {article?.thumbnail &&
                                        <div className={CSS.image}>
                                            <Image img={article.thumbnail} />
                                        </div>
                                    }
                                    {article?.title &&
                                        <Link to={`/${article.full_slug}/`}>
                                            <h3>{article.title}</h3>
                                        </Link>
                                    }
                                </div>

                                {article?.category && article.category[0] &&
                                    <Link className={CSS.categoryTag} to={`/learn/categories/${article.category[0]}/`}>
                                        {query.categoryTags.nodes.find(({value}) => value === article.category[0])?.name}
                                    </Link>
                                }

                                {article?.patientResourcesCategory && article.patientResourcesCategory[0] &&
                                    <Link className={CSS.categoryTag} to={`/patient-resources/categories/${article.patientResourcesCategory[0]}/`}>
                                        {query.patientResourceTags.nodes.find(({value}) => value === article.patientResourcesCategory[0])?.name}
                                    </Link>
                                }
                            </article>
                        )
                    })}
                </div>

            </div>

        </section>
    )
}

export default ListOfArticles